import { first, groupBy, isArray, isEmpty } from 'lodash'
import { largeSizes, legendDefault } from '.'
import {
  defaultExportMenu,
  getColumnSeries,
  getGroupedSeries,
  getLineSeries,
  getStackedSeries
} from '../helpers'

const seriesConfig = ({ el, otherConfig }) => {
  const { type, config } = el

  switch (type) {
    case 'grouped':
      return getGroupedSeries({ series: config, otherConfig })
    case 'line':
      return getLineSeries({ series: config, otherConfig })
    case 'stacked':
      return getStackedSeries({ series: config, otherConfig })
    case 'column':
    default:
      return getColumnSeries({ series: config, otherConfig })
  }
}

const yAxesProcess = ({ series, title, secondAxesTitle, sync, labelColor }) => {
  let yAxes = []
  const yAxisGrouped = groupBy(series, 'yAxis')
  const yAxisKeys = Object.keys(yAxisGrouped)

  if (sync && yAxisKeys.length !== 1) {
    yAxes = yAxisKeys.map((el, index) => {
      if (yAxisKeys.length - 1 === index) {
        return {
          id: el,
          type: 'ValueAxis',
          syncWithAxis: first(yAxisKeys),
          title: {
            text: secondAxesTitle || null,
            fill: labelColor,
            fontSize: 12
          },
          renderer: {
            opposite: true,
            line: {
              fill: labelColor,
              strokeOpacity: 0.3
            },
            labels: {
              fill: labelColor,
              fontSize: 10
            }
          }
        }
      } else {
        return {
          id: el,
          type: 'ValueAxis',
          title: {
            text: title || null,
            fill: labelColor
          },
          renderer: {
            line: {
              fill: labelColor,
              strokeOpacity: 0.3
            },
            labels: {
              fill: labelColor,
              fontSize: 10
            }
          }
        }
      }
    })
  } else {
    yAxes = [
      {
        title: {
          text: title || null,
          fill: labelColor,
          fontSize: 12
        },
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: 10
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: 10
          }
        }
      }
    ]
  }
  return yAxes
}

export default ({ config, data, color, size = 'sm', legendLabels = {} }) => {
  const { series, ...restConfig } = config
  const {
    title,
    xKey,
    scrollbar,
    opposite,
    secondAxesTitle,
    sync,
    disabledAnimations = false,
    exportingMenu
  } = restConfig
  const { labelColor } = color
  const seriesList = []

  series.forEach((el) => {
    const keys = []
    // get custom legend labels with translated values
    Object.keys(legendLabels).forEach((key) => {
      if (el.config.includes(key)) {
        keys.push(legendLabels[key])
      }
    })

    const configSeries = seriesConfig({
      el,
      otherConfig: {
        legendLabel: keys,
        color,
        disabledAnimations,
        ...restConfig
      }
    })

    if (isArray(configSeries)) {
      seriesList.push(...configSeries)
    } else {
      seriesList.push(configSeries)
    }
  })

  const chartConfig = {
    data: data,
    type: 'XYChart',
    series: seriesList,
    yAxes: yAxesProcess({
      series: seriesList,
      title,
      secondAxesTitle,
      opposite,
      sync,
      labelColor
    }),
    cursor: {},
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        rangeChangeDuration: 500,

        renderer: {
          labels: {
            fontSize: !largeSizes.includes(size) && 10,
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0
            }
          },
          line: {
            strokeOpacity: 0.3
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.7,
          maxLabelPosition: 0.98
        }
      }
    ],
    scrollbarX: {
      disabled: !scrollbar,
      animationDuration: 500,
      parent: 'bottomAxesContainer'
    },
    legend: legendDefault(labelColor)
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      chartConfig.exporting = defaultExportMenu
    } else {
      chartConfig.exporting = exportingMenu.config
    }
  }

  return chartConfig
}
